// Synchronous cache for markdown document bodies, populated two ways:
//
// - Server (scripts/prerender.js / src/entry-server.jsx): filled directly
//   via fs before renderToString runs. This is what makes prerendering work
//   at all — BlogPost/GuideDetail/ContentPage normally load bodies via
//   useEffect + a Promise (src/common/content.js), and effects never run
//   during React's synchronous renderToString pass. Checking this cache in
//   each component's initial state lets the first render include the real
//   body instead of a loading skeleton.
// - Client: seeded from window.__PRELOADED_CONTENT__ (embedded by the
//   prerender script into each static page) before the app hydrates, so
//   the browser doesn't redundantly re-fetch content it was already sent.
const cache = new Map();

export const getPreloaded = key => cache.get(key);
export const setPreloaded = (key, value) => cache.set(key, value);

export const hydratePreloadCache = () => {
  if (typeof window === 'undefined' || !window.__PRELOADED_CONTENT__)
    return;
  Object.entries(window.__PRELOADED_CONTENT__).forEach(([key, value]) => cache.set(key, value));
};

// Called server-side after rendering a route, to embed only the entries
// that route actually used (not the whole cache — irrelevant on any other
// page since each route only ever preloads its own body).
export const dumpPreloaded = keys => {
  const out = {};
  keys.forEach(key => {
    if (cache.has(key))
      out[key] = cache.get(key);
  });
  return out;
};
